import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ee6729f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "version" }
const _hoisted_3 = {
  key: 0,
  class: "cache-info"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Offline data is currently caching...")
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "cache-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_EngagementBanner = _resolveComponent("EngagementBanner")!
  const _component_RequestNotificationPermissionPanel = _resolveComponent("RequestNotificationPermissionPanel")!
  const _component_MenuRow = _resolveComponent("MenuRow")!
  const _component_Scrollable = _resolveComponent("Scrollable")!
  const _component_CompanyGoalsModal = _resolveComponent("CompanyGoalsModal")!
  const _component_WebViewScreen = _resolveComponent("WebViewScreen")!

  return (_openBlock(), _createBlock(_component_WebViewScreen, {
    class: "webview-container",
    "no-pad": "",
    title: "More"
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loading, {
            key: 0,
            loading: _ctx.loading
          }, null, 8, ["loading"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Scrollable, { class: "container" }, {
        default: _withCtx(() => [
          _createVNode(_component_EngagementBanner),
          _createVNode(_component_RequestNotificationPermissionPanel),
          (_ctx.showTeamscoreBoard)
            ? (_openBlock(), _createBlock(_component_MenuRow, {
                key: 0,
                "menu-item": {
                    icon: _ctx.IconTeamScoreboard,
                    name: 'Team Scoreboard',
                    id: 'teamscoreboard',
                },
                class: "item",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push({ name: 'teamscoreboard' })))
              }, null, 8, ["menu-item"]))
            : _createCommentVNode("", true),
          (_ctx.showCompanyGoals)
            ? (_openBlock(), _createBlock(_component_MenuRow, {
                key: 1,
                "menu-item": {
                    icon: _ctx.IconCompanyGoals,
                    name: 'Company Goals',
                    id: 'companygoals',
                },
                class: "item",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCompanyGoalsModal = true))
              }, null, 8, ["menu-item"]))
            : _createCommentVNode("", true),
          (_ctx.showNotices)
            ? (_openBlock(), _createBlock(_component_MenuRow, {
                key: 2,
                "menu-item": {
                    icon: _ctx.IconNoticesActive,
                    name: 'Notices',
                    id: 'notices',
                },
                class: "item",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push({ name: 'notices' })))
              }, null, 8, ["menu-item"]))
            : _createCommentVNode("", true),
          (_ctx.showSuggestions)
            ? (_openBlock(), _createBlock(_component_MenuRow, {
                key: 3,
                "menu-item": {
                    icon: _ctx.IconLightBulb,
                    name: 'Suggestions',
                    id: 'suggestions',
                },
                class: "item",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.push({ name: 'suggestions' })))
              }, null, 8, ["menu-item"]))
            : _createCommentVNode("", true),
          (_ctx.showFeedback)
            ? (_openBlock(), _createBlock(_component_MenuRow, {
                key: 4,
                "menu-item": {
                    icon: _ctx.IconTabFeedbackActive,
                    name: 'Feedback',
                    id: 'feedback',
                },
                class: "item",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.router.push({ name: 'feedback' })))
              }, null, 8, ["menu-item"]))
            : _createCommentVNode("", true),
          _createVNode(_component_MenuRow, {
            "menu-item": {
                    icon: _ctx.IconLeaderboard,
                    name: 'Leaderboards',
                    id: 'leaderboards',
                },
            class: "item",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.router.push({ name: 'leaderboards' })))
          }, null, 8, ["menu-item"]),
          (_ctx.showSetting)
            ? (_openBlock(), _createBlock(_component_MenuRow, {
                key: 5,
                "menu-item": {
                    icon: _ctx.IconCog,
                    name: 'Settings',
                    id: 'settings',
                },
                class: "item",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.router.push({ name: 'settings' })))
              }, null, 8, ["menu-item"]))
            : _createCommentVNode("", true),
          _createVNode(_component_MenuRow, {
            "menu-item": {
                    icon: _ctx.IconBetaSwitcher,
                    name: 'Switch to Modern App',
                    id: 'beta-app',
                },
            class: "item",
            onClick: _ctx.switchToBetaApp
          }, null, 8, ["menu-item", "onClick"]),
          (_ctx.canSwitchUser)
            ? (_openBlock(), _createBlock(_component_MenuRow, {
                key: 6,
                "menu-item": {
                    icon: _ctx.IconBetaSwitcher,
                    name: 'View as Someone Else',
                    id: 'view-as-someone-else',
                },
                class: "item",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.router.push({ name: 'viewAs' })))
              }, null, 8, ["menu-item"]))
            : _createCommentVNode("", true),
          _createVNode(_component_MenuRow, {
            "menu-item": {
                    icon: _ctx.IconLogout,
                    name: 'Logout',
                },
            class: "item",
            onClick: _ctx.logout
          }, null, 8, ["menu-item", "onClick"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, _toDisplayString(_ctx.domain), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.decodeUserName) + " | " + _toDisplayString(_ctx.userId), 1),
              _createElementVNode("div", null, "v" + _toDisplayString(_ctx.version), 1),
              (_ctx.currentlyCaching)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                : (_ctx.lastDataCached > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", null, [
                        _createElementVNode("small", null, "Offline data cached: " + _toDisplayString(_ctx.fLastDataCached), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("small", null, "Time used caching: " + _toDisplayString(_ctx.lastTimeSpent), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("small", null, "Cached size: " + _toDisplayString(_ctx.lastDataSize), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ])
          ])
        ], undefined, true),
        _: 1
      }),
      (_ctx.showCompanyGoalsModal)
        ? (_openBlock(), _createBlock(_component_CompanyGoalsModal, {
            key: 1,
            show: _ctx.showCompanyGoalsModal,
            onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showCompanyGoalsModal = false))
          }, null, 8, ["show"]))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}